(function () {
  'use strict';

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function createNotificationController(options) {
    var config = options || {};
    var root = config.root || document;
    var notificationSelector = config.notificationSelector || '.notification';
    var dismissSelector = config.dismissSelector || '[data-dismiss="notification"]';
    var dismissedClass = config.dismissedClass || 'notification--dismissed';

    function getNotifications() {
      return toArray(root.querySelectorAll(notificationSelector));
    }

    function getDismissedNotifications() {
      return getNotifications().filter(function (notification) {
        return notification.hidden || notification.classList.contains(dismissedClass);
      });
    }

    function emit(name, detail) {
      if (typeof CustomEvent !== 'function') {
        return;
      }

      root.dispatchEvent(new CustomEvent(name, {
        bubbles: true,
        detail: detail || {}
      }));
    }

    function dismiss(notification, trigger) {
      if (!notification) {
        return false;
      }

      notification.hidden = true;
      notification.classList.add(dismissedClass);

      emit('notification:dismissed', {
        notification: notification,
        trigger: trigger || null
      });

      return true;
    }

    function restore(notification) {
      if (!notification) {
        return false;
      }

      notification.hidden = false;
      notification.classList.remove(dismissedClass);

      emit('notification:restored', {
        notification: notification
      });

      return true;
    }

    function restoreAll() {
      var restoredCount = 0;

      getDismissedNotifications().forEach(function (notification) {
        if (restore(notification)) {
          restoredCount += 1;
        }
      });

      emit('notification:restored-all', {
        restoredCount: restoredCount
      });

      return restoredCount;
    }

    function onClick(event) {
      var trigger = event.target && event.target.closest ? event.target.closest(dismissSelector) : null;
      var notification;

      if (!trigger || !root.contains(trigger)) {
        return;
      }

      notification = trigger.closest(notificationSelector);
      if (!notification || !root.contains(notification)) {
        return;
      }

      event.preventDefault();
      dismiss(notification, trigger);
    }

    root.addEventListener('click', onClick);

    return {
      root: root,
      dismiss: dismiss,
      restore: restore,
      restoreAll: restoreAll,
      getNotifications: getNotifications,
      getDismissedNotifications: getDismissedNotifications,
      destroy: function () {
        root.removeEventListener('click', onClick);
      }
    };
  }

  window.createNotificationController = createNotificationController;

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = createNotificationController;
  }
})();
